import { IFile } from '../generated-types'
import { useDelete, useGet, usePost } from './reactQuery'

const baseUrl = 'files'

export const endpoints = {
  getFile(fileId: EntityId) {
    return `${baseUrl}/${fileId}`
  },

  getSharedFileUrl(fileUrl: string) {
    return `${baseUrl}/shared?fileUrl=${fileUrl}`
  },

  downloadFile(viewToken: string) {
    return `${baseUrl}/download-file/${viewToken}`
  },

  uploadFile() {
    return `${baseUrl}/upload-file`
  },

  uploadImage() {
    return `${baseUrl}/upload-image`
  },

  deleteFile() {
    return `${baseUrl}/delete-file`
  },

  deleteFileByViewToken(viewToken: string) {
    return `${baseUrl}/delete-file-by-viewtoken/${viewToken}`
  },
}

export const useGetFile = (fileId?: EntityId) => {
  let enabled = fileId !== undefined && fileId !== 0 && fileId !== null
  if (typeof fileId === 'number' && fileId > 0) {
    enabled = true
  } else {
    enabled = false
  }
  return useGet<IFile>(endpoints.getFile(fileId as EntityId), undefined, { enabled: enabled })
}

export const useGetSharedFileUrl = (fileUrl: string, enabled = true) => {
  return useGet<string>(endpoints.getSharedFileUrl(fileUrl), undefined, { enabled: enabled && !!fileUrl })
}

export const useDownloadFile = (viewToken: string) => {
  return useGet<any>(endpoints.downloadFile(viewToken))
}

export const useUploadFile = (isImage: boolean) => {
  return usePost<IFile, FormData>(isImage ? endpoints.uploadImage() : endpoints.uploadFile())
}

export const useDeleteFile = () => {
  return useDelete(endpoints.deleteFile())
}

export const useDeleteFileByViewToken = (viewToken: string) => {
  return useDelete(endpoints.deleteFileByViewToken(viewToken))
}
